module.exports = __webpack_public_path__ + "static/media/add-photo.bca5a58c.svg";